import React from "react";
import { Button, message, Tooltip } from "antd";
// Import the SVG as a React component
import { ReactComponent as MailResendIcon } from "./icons/mail-resend-icon.svg";
import { useAuth } from "../../../auth/AuthContext";
import { resendInvite } from "../utils/api";

const ResendInvite = ({ patientId, inviteId, reload, setPageLoading }) => {
  const auth = useAuth();

  const handleResend = async () => {
    setPageLoading(true);
    try {
      await resendInvite({
        patientId,
        inviteId,
        token: auth.user?.["access_token"],
      });
      message.success("Invite resent successfully");
      reload();
    } catch (err) {
      message.error(`Failed to resend invite: ${err.message || err}`);
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <Tooltip title="Resend Invite">
      <Button
        icon={<MailResendIcon style={{ width: 16, height: 16, verticalAlign: "middle" }} />}
        onClick={handleResend}
        size="small"
        type="default"
      />
    </Tooltip>
  );
};

export default ResendInvite;
